// extracted by mini-css-extract-plugin
export default {"wrapperStyles":"PlanList_wrapperStyles__VgmGV"};